var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHerd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stove-svgrepo-com(1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.6274 2.53125H11.9528C8.95646 2.53125 6.32776 5.02706 6.32776 7.87282V80.3672C6.32776 80.7171 6.61126 81 6.96057 81H74.0387C74.388 81 74.6715 80.7171 74.6721 80.3672V7.87282C74.6721 4.87772 72.456 2.53125 69.6274 2.53125ZM73.4059 79.7344H7.59338V7.87282C7.59338 5.70164 9.63041 3.79688 11.9522 3.79688H69.6267C71.7814 3.79688 73.4059 5.54977 73.4059 7.87282V79.7344Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.2147 6.33447C31.1365 6.33447 29.4463 8.02535 29.4463 10.1029C29.4463 12.1804 31.1365 13.8713 33.2147 13.8713C35.2928 13.8713 36.9831 12.1804 36.9831 10.1029C36.9831 8.02535 35.2928 6.33447 33.2147 6.33447ZM33.2147 12.6056C31.8345 12.6056 30.7119 11.483 30.7119 10.1029C30.7119 8.72271 31.8345 7.6001 33.2147 7.6001C34.5949 7.6001 35.7175 8.72271 35.7175 10.1029C35.7175 11.483 34.5949 12.6056 33.2147 12.6056Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.4218 6.33447C46.3437 6.33447 44.6534 8.02535 44.6534 10.1029C44.6534 12.1804 46.3437 13.8713 48.4218 13.8713C50.4994 13.8713 52.1902 12.1804 52.1902 10.1029C52.1902 8.02535 50.5 6.33447 48.4218 6.33447ZM48.4218 12.6056C47.0417 12.6056 45.9191 11.483 45.9191 10.1029C45.9191 8.72271 47.0417 7.6001 48.4218 7.6001C49.8014 7.6001 50.9246 8.72271 50.9246 10.1029C50.9246 11.483 49.802 12.6056 48.4218 12.6056Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0083 6.33447C15.9301 6.33447 14.2399 8.02535 14.2399 10.1029C14.2399 12.1804 15.9301 13.8713 18.0083 13.8713C20.0864 13.8713 21.7767 12.1804 21.7767 10.1029C21.7767 8.02535 20.0864 6.33447 18.0083 6.33447ZM18.0083 12.6056C16.6281 12.6056 15.5055 11.483 15.5055 10.1029C15.5055 8.72271 16.6281 7.6001 18.0083 7.6001C19.3884 7.6001 20.511 8.72271 20.511 10.1029C20.511 11.483 19.3884 12.6056 18.0083 12.6056Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M63.6284 6.33447C61.5508 6.33447 59.8606 8.02535 59.8606 10.1029C59.8606 12.1804 61.5508 13.8713 63.6284 13.8713C65.7065 13.8713 67.3968 12.1804 67.3968 10.1029C67.3968 8.02535 65.7065 6.33447 63.6284 6.33447ZM63.6284 12.6056C62.2488 12.6056 61.1262 11.483 61.1262 10.1029C61.1262 8.72271 62.2488 7.6001 63.6284 7.6001C65.0079 7.6001 66.1311 8.72271 66.1311 10.1029C66.1311 11.483 65.0085 12.6056 63.6284 12.6056Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.7496 31.6406H19.6168C17.8722 31.6406 16.4528 33.06 16.4528 34.8047V60.1172C16.4528 61.8619 17.8722 63.2812 19.6168 63.2812H60.7496C62.4943 63.2812 63.9137 61.8619 63.9137 60.1172V34.8047C63.9137 33.06 62.4943 31.6406 60.7496 31.6406ZM62.6481 60.1172C62.6481 61.1639 61.7963 62.0156 60.7496 62.0156H19.6168C18.5701 62.0156 17.7184 61.1639 17.7184 60.1172V34.8047C17.7184 33.758 18.5701 32.9062 19.6168 32.9062H60.7496C61.7963 32.9062 62.6481 33.758 62.6481 34.8047V60.1172Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62.3399 22.1484H19.2802C16.511 22.1484 14.2576 24.4025 14.2576 27.1736C14.2576 28.2222 15.1093 29.0758 16.156 29.0758C17.2027 29.0758 18.0544 28.2228 18.0544 27.1749C18.0544 26.4971 18.6044 25.9453 19.2802 25.9453H62.3393C63.0151 25.9453 63.5644 26.4971 63.5644 27.1749C63.5644 28.2241 64.4162 29.0784 65.4629 29.0784C66.5102 29.0784 67.3613 28.2247 67.3619 27.1749C67.3619 24.4031 65.1085 22.1484 62.3399 22.1484ZM65.4635 27.8127C65.1148 27.8127 64.8307 27.5267 64.8307 27.1749C64.8307 25.7991 63.7131 24.6797 62.3399 24.6797H19.2802C17.9064 24.6797 16.7888 25.7991 16.7888 27.1749C16.7888 27.5254 16.5047 27.8102 16.156 27.8102C15.8073 27.8102 15.5232 27.5248 15.5232 27.1736C15.5232 25.1005 17.209 23.4141 19.2802 23.4141H62.3399C64.4111 23.4141 66.0963 25.1011 66.0963 27.1749C66.0963 27.5267 65.8122 27.8127 65.4635 27.8127Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.5465 16.4531H6.96057C6.61126 16.4531 6.32776 16.736 6.32776 17.0859C6.32776 17.4359 6.61126 17.7188 6.96057 17.7188H64.5465C64.8958 17.7188 65.1793 17.4359 65.1793 17.0859C65.1793 16.736 64.8958 16.4531 64.5465 16.4531Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M74.0387 16.4531H68.9762C68.6269 16.4531 68.3434 16.736 68.3434 17.0859C68.3434 17.4359 68.6269 17.7188 68.9762 17.7188H74.0387C74.388 17.7188 74.6715 17.4359 74.6715 17.0859C74.6715 16.736 74.388 16.4531 74.0387 16.4531Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M64.5465 70.875H6.96057C6.61126 70.875 6.32776 71.1579 6.32776 71.5078C6.32776 71.8578 6.61126 72.1406 6.96057 72.1406H64.5465C64.8958 72.1406 65.1793 71.8578 65.1793 71.5078C65.1793 71.1579 64.8958 70.875 64.5465 70.875Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M74.0387 70.875H68.9762C68.6269 70.875 68.3434 71.1579 68.3434 71.5078C68.3434 71.8578 68.6269 72.1406 68.9762 72.1406H74.0387C74.388 72.1406 74.6715 71.8578 74.6715 71.5078C74.6715 71.1579 74.388 70.875 74.0387 70.875Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.9933 12.1925L15.9181 7.11795C15.6707 6.87052 15.2708 6.87052 15.0233 7.11795C14.7759 7.36538 14.7759 7.76531 15.0233 8.01274L20.0985 13.0873C20.2219 13.2107 20.3839 13.2727 20.5459 13.2727C20.7079 13.2727 20.8693 13.2107 20.9933 13.0873C21.2407 12.8398 21.2407 12.4399 20.9933 12.1925Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M36.1997 12.1925L31.1246 7.11795C30.8771 6.87052 30.4772 6.87052 30.2298 7.11795C29.9823 7.36538 29.9823 7.76531 30.2298 8.01274L35.3049 13.0873C35.4283 13.2107 35.5903 13.2727 35.7523 13.2727C35.9143 13.2727 36.0763 13.2107 36.1997 13.0873C36.4471 12.8398 36.4471 12.4399 36.1997 12.1925Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M51.4063 12.1925L46.3311 7.11795C46.0837 6.87052 45.6837 6.87052 45.4363 7.11795C45.1889 7.36538 45.1889 7.76531 45.4363 8.01274L50.5115 13.0873C50.6349 13.2107 50.7969 13.2727 50.9589 13.2727C51.1209 13.2727 51.2829 13.2107 51.4063 13.0873C51.6537 12.8398 51.6537 12.4399 51.4063 12.1925Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M66.6133 12.1925L61.5381 7.11795C61.2907 6.87052 60.8908 6.87052 60.6433 7.11795C60.3959 7.36538 60.3959 7.76531 60.6433 8.01274L65.7185 13.0873C65.8419 13.2107 66.0039 13.2727 66.1659 13.2727C66.3273 13.2727 66.4893 13.2107 66.6133 13.0873C66.8607 12.8398 66.8607 12.4399 66.6133 12.1925Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M68.9762 0H12.0231C11.6738 0 11.3903 0.282867 11.3903 0.632812V3.16406C11.3903 3.51401 11.6738 3.79688 12.0231 3.79688C12.3724 3.79688 12.6559 3.51401 12.6559 3.16406V1.26562H68.3434V3.16406C68.3434 3.51401 68.6269 3.79688 68.9762 3.79688C69.3255 3.79688 69.609 3.51401 69.609 3.16406V0.632812C69.609 0.282867 69.3255 0 68.9762 0Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M37.4185 38.811L30.5265 31.9197C30.2791 31.6723 29.8792 31.6723 29.6317 31.9197C29.3843 32.1671 29.3843 32.5671 29.6317 32.8145L36.5237 39.7058C36.6471 39.8292 36.8091 39.8912 36.9711 39.8912C37.1331 39.8912 37.2951 39.8292 37.4185 39.7058C37.6659 39.4584 37.6659 39.0585 37.4185 38.811Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M46.912 48.3051L40.5826 41.9751C40.3351 41.7277 39.9352 41.7277 39.6878 41.9751C39.4403 42.2226 39.4403 42.6225 39.6878 42.8699L46.0172 49.1999C46.1406 49.3233 46.3026 49.3854 46.4646 49.3854C46.6266 49.3854 46.7886 49.3233 46.912 49.1999C47.1594 48.9525 47.1594 48.5526 46.912 48.3051Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M54.0754 62.3991L34.2431 42.5655C33.9957 42.318 33.5957 42.318 33.3483 42.5655C33.1009 42.8129 33.1009 43.2128 33.3483 43.4603L53.1806 63.2939C53.304 63.4173 53.466 63.4793 53.628 63.4793C53.79 63.4793 53.952 63.4179 54.0754 63.2939C54.3229 63.0464 54.3229 62.6465 54.0754 62.3991Z",
    fill: "black"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerd);
export default __webpack_public_path__ + "static/media/herd.a782f953d0fb0b2f5886f2771451ffa9.svg";
export { ForwardRef as ReactComponent };